import { useQuery } from '@tanstack/react-query';
import {
	decodeTokenPayload,
	getAccessTokenWithFallback
} from 'features/communication-bridge/tokenStore';

export function useGetIsUserAdminQuery() {
	return useQuery({
		queryKey: ['isUserAdmin'],
		queryFn: async () => {
			try {
				const token = await getAccessTokenWithFallback();
				const payload = decodeTokenPayload(token);
				return payload?.['custom:role'] === 'coreprjctssuperadmin';
			} catch {
				return false;
			}
		}
	});
}
